import { useEffect, useRef } from "react"

type ExceptionRef = React.RefObject<HTMLElement>

export const useCrossFrameOutsideClick = (
    callback: () => void,
    exceptionRefs: ExceptionRef[] = [],
    trustedOrigins: string[],
    iframeMessage: string = "outside-click",
): React.RefObject<HTMLDivElement> => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node
            const isClickedInsideMain =
                ref.current && ref.current.contains(target)
            const isClickedInsideException = exceptionRefs.some(
                (exceptionRef) =>
                    exceptionRef.current &&
                    exceptionRef.current.contains(target),
            )

            if (!isClickedInsideMain && !isClickedInsideException) {
                callback()
            }
        }

        const handleMessageFromIframe = (event: MessageEvent) => {
            if (
                trustedOrigins.includes(event.origin) &&
                event.data === iframeMessage
            ) {
                callback()
            }
        }

        document.addEventListener("mouseup", handleClickOutside)
        document.addEventListener("touchend", handleClickOutside)
        window.addEventListener("message", handleMessageFromIframe)

        return () => {
            document.removeEventListener("mouseup", handleClickOutside)
            document.removeEventListener("touchend", handleClickOutside)
            window.removeEventListener("message", handleMessageFromIframe)
        }
    }, [callback, exceptionRefs])

    return ref
}
